import { HiOutlinePencilAlt } from 'react-icons/hi'

import { IconButton, Skeleton, Tooltip } from '@chakra-ui/react'

interface EditPencilButtonIProps {
  onClick: () => void
  tooltipLabel: string
  disabledTooltipLabel: string
  isLoading: boolean
  isDisabled: boolean
}

export const EditPencilButton = ({
  onClick,
  isLoading,
  tooltipLabel,
  disabledTooltipLabel,
  isDisabled,
}: EditPencilButtonIProps) => {
  return (
    <Skeleton isLoaded={!isLoading}>
      <Tooltip
        label={isDisabled ? disabledTooltipLabel : tooltipLabel}
        shouldWrapChildren
      >
        <IconButton
          aria-label={tooltipLabel}
          icon={<HiOutlinePencilAlt size={18} />}
          isDisabled={isDisabled}
          onClick={onClick}
          size='sm'
          variant='ghost'
        />
      </Tooltip>
    </Skeleton>
  )
}
